import { apiProxyRequest } from "Api/apiProxyRequest";
import { ProjectSetting } from "Reducers/projectSettings";

export type Interval = "2w" | "4w";
export type DayOfWeek = 0 | 1 | 2 | 3 | 4 | 5 | 6;
export type TimeString = string;

export interface MaintenanceWindow {
  enabled: boolean;
  recurrence: MaintenanceWindowRecurrence;
}

export interface MaintenanceWindowRecurrence {
  interval?: Interval;
  day_of_week?: DayOfWeek;
  time?: TimeString;
}

export type UpdateMaintenanceWindowResponse = {
  status: string;
  code: number;
  _embedded: {
    entity: ProjectSetting;
  };
};

export const updateMaintenanceWindowRequest = (
  projectId: string,
  maintenanceWindow: { recurrence: MaintenanceWindowRecurrence }
) =>
  apiProxyRequest<UpdateMaintenanceWindowResponse>(
    `/projects/${projectId}/settings`,
    "PATCH",
    {
      maintenance_window: maintenanceWindow
    }
  );
